import { authenticatedFetch } from '../../../api/request';

const getHasAgreedToTermsOfUse = () => {
    return authenticatedFetch('/v5/userAgreementTerms/hasAgreed');
};

export default getHasAgreedToTermsOfUse;
